import {getQuery} from "@/modules/common/utils";

const SALE_PATH = 'business/payments/v1/carts';

const get = uid => getQuery(`${SALE_PATH}/${uid}`, {new_api: true});

export const saleService = {
  get
}
